class CartGift extends HTMLElement {
  connectedCallback () {
    this.constants = {
      PRODUCT_STATUS: {
        ADD: '1',
        REMOVE: '0'
      }
    }
    this.cleanupFuncs = []

    this.cartEl = this.closest('[data-section-id="cart"]')
    this.buttonEl = this.querySelector('.js-cart-gift-button')
    this.messageEnableEl = this.querySelector('.js-cart-gift-message-enable-input')
    this.messageEl = this.querySelector('.js-cart-gift-message-input')
    this.productEl = this.querySelector('.js-cart-gift-product')

    this.showGift = this.showGift.bind(this)
    this.hideGift = this.hideGift.bind(this)
    this.toggleMessage = this.toggleMessage.bind(this)
    this.submit = this.submit.bind(this)

    this.handleEvents()
  }

  disconnectedCallback () {
    this.destroyEvents()
  }

  destroyEvents () {
    this.cleanupFuncs.forEach(func => {
      if (typeof func === 'function') {
        func.call(this)
      }
    })
  }

  getFormData() {
    const formData = new FormData()

    const inputEls = this.querySelectorAll('input[name]:not([disabled]), textarea[name]:not([disabled])')

    inputEls.forEach(inputEl => {
      if ((inputEl.type === 'checkbox' || inputEl.type === 'radio')) {
        formData.append(inputEl.name, inputEl.checked ? '1' : '0')
        return
      }

      formData.append(inputEl.name, inputEl.value)
    })

    return formData
  }

  showGift() {
    this.cartEl.classList.add('show-gift')
    this.classList.add('is-show')
  }

  hideGift() {
    this.cartEl.classList.remove('show-gift')
    this.classList.remove('is-show')
    this.classList.add('is-hiding')

    setTimeout(() => {
      this.classList.remove('is-hiding')
    }, 1000)
  }

  toggleMessage(e) {
    const isChecked = e.currentTarget.checked
    this.messageEl?.toggleAttribute('disabled', !isChecked)
  }

  async handleGiftMessageInCart(message = '', enabled = false) {
    const config = {
      routeUrl: window.routes.cartUpdateUrl,
      body: {
        note: enabled ? message : ''
      },
      failedMessage: `Failed ${enabled ? 'adding' : 'removing'} gift message`
    }

    try {
      await fetch(config.routeUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        credentials: 'same-origin',
        body: JSON.stringify(config.body)
      })

      return true
    } catch (error) {
      console.error(config.failedMessage)

      return false
    }
  }

  async handleGiftProductInCart(variantId = '', productStatus = -1) {
    const config = {
      body: {},
      routeUrl: '',
      failedMessage: ''
    }

    switch (productStatus) {
      case this.constants.PRODUCT_STATUS.ADD:
        config.routeUrl = `${window.routes.cartAddUrl}.js`
        config.body = {
          items: [
            {
              id: variantId,
              quantity: 1,
              properties: {
                _isGiftWrapping: 'Yes'
              }
            }
          ]
        }
        config.failedMessage = `Failed adding gift product ${variantId} to cart`
        break
      case this.constants.PRODUCT_STATUS.REMOVE:
        config.routeUrl = `${window.routes.cartChangeUrl}.js`
        config.body = {
          id: variantId,
          quantity: 0
        }
        config.failedMessage = `Failed removing gift product ${variantId} from cart`
        break
    }

    if (!variantId || !config.routeUrl) return

    try {
      await fetch(config.routeUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        credentials: 'same-origin',
        body: JSON.stringify(config.body)
      })

      return true
    } catch (error) {
      console.error(config.failedMessage)

      return false
    }
  }

  async submit() {
    const promises = []
    const formData = this.getFormData()
    const giftId = formData.get('gift-product')
    const giftStatus = formData.get('gift-product-add')
    const giftMessageEnabled = formData.get('gift-message-enable') === '1'
    const giftMessage = formData.get('gift-message')

    promises.push(
      await this.handleGiftProductInCart(giftId, giftStatus),
      await this.handleGiftMessageInCart(giftMessage, giftMessageEnabled)
    )

    try {
      await Promise.allSettled(promises)

      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true
      }))

      return true
    } catch (error) {
      console.error(`Failed handling gift options`)

      return false
    }
  }

  handleEvents () {
    this.cartEl.addEventListener('cart:show-gift', this.showGift)
    this.cartEl.addEventListener('cart:back-from-gift', this.hideGift)
    this.messageEnableEl.addEventListener('change', this.toggleMessage)
    this.buttonEl.addEventListener('click', this.submit)

    this.cleanupFuncs.push(() => this.cartEl.removeEventListener('cart:show-gift', this.showGift))
    this.cleanupFuncs.push(() => this.cartEl.removeEventListener('cart:back-from-gift', this.hideGift))
    this.cleanupFuncs.push(() => this.messageEnableEl.removeEventListener('change', this.toggleMessage))
    this.cleanupFuncs.push(() => this.buttonEl.removeEventListener('click', this.submit))
  }
}

customElements.define('cart-gift', CartGift)
